import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import propTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import * as Next from '@alife/next';
import Tinymce from '@alife/super-text';
import fetchJsonp from 'fetch-jsonp';
import * as tarot from '@alife/tarot';
import ctoken from '@alife/puck-csrftoken';
import * as redux from 'redux';
import * as dva from 'dva';
import dvaImmer from 'dva-immer';

import MessageTip from './components/message-tip';
import Image from './components/image';
import log from './common/log';
import puckParameter from './common/puck-middleware';
import errLog from './common/retcode-log';
import Utils from './common/utils';
import I18N from './common/i18n';
import * as webIO from './common/web-io';
import * as requestHelper from './common/request';
import CardMap from './common/card-map';

const IcbuIM = window.IcbuIM = {};
// 给fusion-webpack-plugin使用
window.Next = Next;

IcbuIM.react = React;
IcbuIM['prop-types'] = propTypes;
IcbuIM['react-dom'] = ReactDOM;
IcbuIM.classnames = classNames;
IcbuIM['@alife/next'] = Next;
IcbuIM['@alife/tarot'] = tarot;
IcbuIM['@alife/super-text'] = Tinymce;
IcbuIM['react-addons-css-transition-group'] = ReactCSSTransitionGroup;
IcbuIM['fetch-jsonp'] = fetchJsonp;
IcbuIM['@alife/bc-i18n'] = I18N;
IcbuIM.redux = redux;
IcbuIM.dva = dva;
IcbuIM['dva-immer'] = dvaImmer;

IcbuIM.React = React;
IcbuIM.propTypes = propTypes;
IcbuIM.ReactDOM = ReactDOM;
IcbuIM.Next = Next;
IcbuIM.Tinymce = Tinymce;
IcbuIM.ReactCSSTransitionGroup = ReactCSSTransitionGroup;

IcbuIM.lib = {};
IcbuIM.lib.MessageTip = MessageTip;
IcbuIM.lib.Image = Image;
IcbuIM.lib.log = log;
IcbuIM.lib.ctoken = ctoken;
IcbuIM.lib.puckParameter = puckParameter;
IcbuIM.lib.errLog = errLog;
IcbuIM.lib.Utils = Utils;
IcbuIM.lib.I18N = I18N;
IcbuIM.lib.webIO = webIO;
IcbuIM.lib.requestHelper = requestHelper;
IcbuIM.lib.CardMap = CardMap;

for (const key in IcbuIM) {
  // eslint-disable-next-line
  exports[key] = IcbuIM[key];
}

export const externalConfig = (() => {
  let ret = {};
  Object.keys(IcbuIM).forEach((key) => {
    ret[key] = `IcbuIM['${key}']`;
  });
  return ret;
})();

export default IcbuIM;
